<template>
	<p :class="style">{{ trans(`rotations.elections.candidates.participation_options.${answer}`) }}</p>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {computed, type ComputedRef, defineProps} from 'vue'
import {RotationCandidateParticipation} from '@/Types/Enums/RotationCandidateParticipation'

const props = defineProps<{
	answer: RotationCandidateParticipation,
}>()

const style: ComputedRef<string> = computed(() => {
	if(props.answer === RotationCandidateParticipation.won){
		return 'text-red-700'
	} else if(props.answer === RotationCandidateParticipation.no){
		return 'text-green-700'
	} else {
		return 'text-yellow-700'
	}
})
</script>
